import { CollectionResource } from 'dy-frontend-http-repository/lib/data/resources';
import { ModelSchemaResource } from 'dy-frontend-http-repository/lib/modules/AiImage/resources';
import domain from './domain';
import { resetModelSchemas } from './events';

// Fetches list of models and their schema
export const $modelSchemas = domain
    .createStore<CollectionResource<ModelSchemaResource, {}> | null>(null)
    .reset(resetModelSchemas);
